import { render, staticRenderFns } from "./Indes.vue?vue&type=template&id=526999a6&scoped=true&"
import script from "./Indes.vue?vue&type=script&lang=js&"
export * from "./Indes.vue?vue&type=script&lang=js&"
import style0 from "./Indes.vue?vue&type=style&index=0&id=526999a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526999a6",
  null
  
)

export default component.exports